import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AddVehiclesService } from '../add-vehicles/add-vehicles.service';
import { AddPackageService } from './add-package.service';
// import {} from 'googlemaps';
     
@Component({
  selector: 'app-add-package',
  templateUrl: './add-package.component.html',
  styleUrls: ['./add-package.component.sass']
})
export class AddPackageComponent implements OnInit {
  senderName="";
  receiverName="";
  isImageUploaded=false;
  senderMobile="";
  receiverMobile="";
  senderEmail="";
  receiverEmail="";
  senderAddress="";
  receiverAddress="";
  senderLatitude="";
  senderLongtitude="";
  receiverLatitude="";
  receiverLongtitude="";
  country="";
  state="";
  city="";
  shipmentType="";
  distance="";
  packageDesc="";
  nosPackage="";
  packageDeliveryPrice="";
  packageWeight="";
  driverTip="";
  specialInstructions="";
  isSendBySMS=true;
  isSendByEMAIL=false;
  directionsService:any;
  directionsRenderer:any;

  stopsBtn=false;
  closeResult: string;

  vehicleId="";
  vehicleName="";
  vehicleImage="";
  stopReceiverName="";
  stopReceiverNo="";
  stopReceiverAddress="";
  stopReceiverLatitude="";
  stopReceiverLongtitude="";
  stopageArray=[];

  allVehiclesList="";
  selectedVehicleData:any;
  couponCode="";
  isCouponValid=false;

  fareTip:any="";
  labourCost:any = "";
  couponCost:any ="";
  netFare:any ="";
  totalAmount:any ="";
  constructor(private spinner:NgxSpinnerService,
              private addpackageService:AddPackageService,
              private toastr: ToastrService,
              private router:Router,
              private modalService: NgbModal,
              private datepipe : DatePipe,
              private addvehicelService : AddVehiclesService) { }

  ngOnInit(): void {
    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer();

    this.getAllVehicles()
}


getAllVehicles(){
    this.spinner.show();
    let data = { isDeleted : 0 }
    this.addpackageService.getAllVehicle(data).subscribe((result:any)=>{
      this.spinner.hide();
      if(result.statusCode == 200){
        this.spinner.hide();
        this.allVehiclesList  = result.data;
      }else{  
        this.spinner.hide();
        this.toastr.error(result.message)
      }
    })
  }

  isLabourAvailable=false;
  labourStatus=false;
  getSelectedVehicle(data){
    if(data){
      this.selectedVehicleData = {};
       this.selectedVehicleData = JSON.parse(data);
      console.log(this.selectedVehicleData)
      this.vehicleId = this.selectedVehicleData._id;
      this.vehicleName = this.selectedVehicleData.vehicleName;
      this.vehicleImage = this.selectedVehicleData.images
      this.isLabourAvailable = this.selectedVehicleData.labourAvailable; 
      this.labourStatus = this.selectedVehicleData.labourAvailable;
      this.calculateBillDetails();
    }else{
      this.vehicleName ="";
      this.isLabourAvailable = false;
    }
  }

  calculateBillDetails(){

    let labour_cost  = this.isLabourAvailable  == true ? environment.labourCost : 0;
    let coupon_cost = this.isCouponValid == true ? Number(this.selectedVehicleData.originalPrice)-Number(this.selectedVehicleData.discountedPrice) : 0;
    let originalPrice = Number(this.selectedVehicleData.originalPrice)

    this.fareTip = originalPrice + labour_cost ;
    this.labourCost =this.isLabourAvailable  == true ? environment.labourCost : 0;
    this.couponCost = this.isCouponValid == true ? environment.couponCost : 0;

    this.netFare = originalPrice +  labour_cost  - coupon_cost;
    this.totalAmount = originalPrice +  labour_cost  - coupon_cost;
  }

   // Select image code start
   isValidImage: any;
   imageUrl = "";
   getVehicleImage(event) {
     if (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/png') {
       this.isValidImage = false;
         this.addvehicelService.addImage(event.target.files[0]).subscribe((result:any)=>{
           console.log(result)
           if(result.statusCode == 200){
               this.isImageUploaded = true;
               this.imageUrl = result.photoUrl;
           }else{
             this.isImageUploaded = false;
             this.imageUrl = "";
           }
           this.isValidImage = false;
         })
 
     } else {
       this.isValidImage = true;
       this.isImageUploaded = false;
     }
   }


  addPackage(){
    let adminInfo = JSON.parse(sessionStorage.getItem('adminInformation'))
    let data = {
      "userId" : adminInfo._id,
      "deviceToken" : "",
      "fromAddress" : this.senderAddress,
      "toAddress" : this.receiverAddress,
      "fromLatitude" : this.senderLatitude,
      "fromLongitude" : this.senderLongtitude,
      "toLatitude" : this.receiverLatitude , 
      "toLongitude" : this.receiverLongtitude,
      "senderName" : this.senderName , 
      "senderMobile" : this.senderMobile,
      "senderEmail" : this.senderEmail,
      "receiverName" : this.receiverName,
      "receiverMobile" : this.receiverMobile,
      "receiverEmail" : this.receiverEmail,
      "city" : this.city,
      "state" : this.state,
      "country" : this.country,
      "specialInstructions" : this.specialInstructions,
      "packageDescription" : this.packageDesc,
      "shipmentType" : this.shipmentType,
      "priceForPackageDelivery" : this.packageDeliveryPrice,
      "sendBySms" : this.isSendBySMS,
      "sendByEmail" : this.isSendByEMAIL,
      "noOfPackages" : this.nosPackage,
      "distance" : this.distance,
      "driverTip" : this.driverTip,
      "weight"  : this.packageWeight,
      "stops": {
          "stop1": {
            "address": this.stopageArray[0]? this.stopageArray[0].address : "",
            "latitude": this.stopageArray[0]? this.stopageArray[0].latitude : "",
            "longitude": this.stopageArray[0]? this.stopageArray[0].longitude : "",
            "receiverName": this.stopageArray[0]? this.stopageArray[0].receiverName : "",
            "receiverPhoneNo": this.stopageArray[0]? this.stopageArray[0].receiverPhoneNo : ""
          },
          "stop2": {
            "address": this.stopageArray[1]? this.stopageArray[1].address : "",
            "latitude": this.stopageArray[1]? this.stopageArray[1].latitude : "",
            "longitude": this.stopageArray[1]? this.stopageArray[1].longitude : "",
            "receiverName": this.stopageArray[1]? this.stopageArray[1].receiverName : "",
            "receiverPhoneNo": this.stopageArray[1]? this.stopageArray[1].receiverPhoneNo : ""
          },
          "stop3": {
            "address": this.stopageArray[2]? this.stopageArray[2].address : "",
            "latitude": this.stopageArray[2]? this.stopageArray[2].latitude : "",
            "longitude": this.stopageArray[2]? this.stopageArray[2].longitude : "",
            "receiverName": this.stopageArray[2]? this.stopageArray[2].receiverName : "",
            "receiverPhoneNo": this.stopageArray[2]? this.stopageArray[2].receiverPhoneNo : ""
          },
          "stop4": {
            "address": this.stopageArray[3]? this.stopageArray[3].address : "",
            "latitude": this.stopageArray[3]? this.stopageArray[3].latitude : "",
            "longitude": this.stopageArray[3]? this.stopageArray[3].longitude : "",
            "receiverName": this.stopageArray[3]? this.stopageArray[3].receiverName : "",
            "receiverPhoneNo": this.stopageArray[3]? this.stopageArray[3].receiverPhoneNo : ""
          }
      },
      "billDetails" : {
        "fareTip": this.fareTip,
        "labourCost": this.labourCost,
        "couponDiscount": this.couponCost,
        "netFare": this.netFare,
        "totalAmount": this.totalAmount
      },
      "paymentDetails": {
        "paymentId": "1234",
        "paymentMethod": "Paytm",
        "status": 1,
        "walletAmount": 500,
        "totalAmount": 1600
    },
      "goldMembership" : 0,
      "photos" : this.imageUrl,
      "vehicleId": this.vehicleId,
      "vehicleImage": this.vehicleImage,
      "vehicleName": this.vehicleName,
      "cancelReason": "",
      "helperOption": this.labourCost? true : false,
      "helperBasicAmount": this.labourCost? this.labourCost : 0,
      "driverId" :  "",
      "signatureStatus" : false
    }
    console.log(data)
    this.spinner.show();
    this.addpackageService.addPackage(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        let todayDate = new Date();
        let sendKey = {
          "vehicleId": this.selectedVehicleData.vehicleId,
          "packageId": result.data[0].packageID,
          "bookingDate": this.datepipe.transform(todayDate, "dd/MM/yyyy"),
          "bookingTime": this.datepipe.transform(todayDate, "hh:mm a"),
          "bookingStatus": 1
        }
        console.log("booking data ", sendKey)
        this.addpackageService.vehicleBooking(sendKey).subscribe((result1: any) => {
          if (result1.statusCode == 200) {
            this.spinner.hide();
            this.toastr.success(result1.message)
            this.router.navigateByUrl('dashboard/package');
          } else {
            this.spinner.hide();
            this.toastr.error(result1.message)
          }
        })
      } else {
        this.spinner.hide();
        this.toastr.error(result.message)
      }
    })
  }

 
  getSenderAddress(address:any){
    var country , state , city;
    if(address.address_components.length == 3){
      country = address.address_components[2].long_name,
      state = address.address_components[1].long_name
      city = address.address_components[0].long_name
    }else if(address.address_components.length == 4){
      country = address.address_components[3].long_name,
      state = address.address_components[2].long_name
      city = address.address_components[1].long_name
      city = address.address_components[0].long_name
    }else if(address.address_components.length == 5){
      country = address.address_components[4].long_name,
      state = address.address_components[3].long_name
      city = address.address_components[0].long_name
    }else if(address.address_components.length == 6){
      country = address.address_components[4].long_name,
      state = address.address_components[3].long_name
      city = address.address_components[2].long_name
    }
    // let sendData = {
    //   "city" : city,
    //   "state" : state,
    //   "country" : country
    // }
    // this.spinner.show();
    // this.addpackageService.checkVerifyCity(sendData).subscribe((result:any)=>{
    //   if(result.statusCode == 200){
    //     this.spinner.hide();
        this.senderAddress = address.name;
        this.senderLatitude = address.geometry.location.lat()
        this.senderLongtitude = address.geometry.location.lng()
        this.calculateDistanceBwLatLong()
    //     console.log('this.senderAddress  ',this.senderAddress)
    //   }else{
    //     this.spinner.hide();
    //     this.toastr.error("City Not Verified");
    //     this.distance = "";
    //   }
    // })


  }


  getReceiverAddress(address:any){
    if(address.address_components.length == 3){
      this.country = address.address_components[2].long_name;
      this.state = address.address_components[1].long_name;
      this.city = address.address_components[0].long_name;
    }else if(address.address_components.length == 4){
      this.country = address.address_components[3].long_name,
      this.state = address.address_components[2].long_name
      this.city = address.address_components[0].long_name
    }else if(address.address_components.length == 5){
      this.country = address.address_components[4].long_name,
      this.state = address.address_components[3].long_name
      this.city = address.address_components[0].long_name
    }else if(address.address_components.length == 6){
      this.country = address.address_components[4].long_name,
      this.state = address.address_components[3].long_name
      this.city = address.address_components[2].long_name
    }
    // let sendData = {
    //   "city" : this.city,
    //   "state" : this.state,
    //   "country" : this.country
    // }
    // this.spinner.show();
    // this.addpackageService.checkVerifyCity(sendData).subscribe((result:any)=>{
    //   if(result.statusCode == 200){
    //     this.spinner.hide();
        this.receiverAddress = address.name;
        this.receiverLatitude = address.geometry.location.lat()
        this.receiverLongtitude = address.geometry.location.lng()
        this.calculateDistanceBwLatLong()
    //   }else{
    //     this.spinner.hide();
    //     this.toastr.error("City Not Verified")
    //     this.city = "";
    //     this.state = "";
    //     this.country = "";
    //     this.distance = "";
    //   }
    // })

  }

  getStopageReceiverAddress(address){
    var country , state , city;
    if(address.address_components.length == 3){
      country = address.address_components[2].long_name,
      state = address.address_components[1].long_name
      city = address.address_components[0].long_name
    }else if(address.address_components.length == 4){
      country = address.address_components[3].long_name,
      state = address.address_components[2].long_name
      city = address.address_components[0].long_name
    }else if(address.address_components.length == 5){
      country = address.address_components[4].long_name,
      state = address.address_components[3].long_name
      city = address.address_components[0].long_name
    }else if(address.address_components.length == 6){
      country = address.address_components[5].long_name,
      state = address.address_components[4].long_name
      city = address.address_components[1].long_name
    }
    // let sendData = {
    //   "city" : city,
    //   "state" : state,
    //   "country" : country
    // }
    // this.spinner.show()
    // this.addpackageService.checkVerifyCity(sendData).subscribe((result:any)=>{
    //       if(result.statusCode == 200){
    //         this.spinner.hide();
            this.stopReceiverAddress = address.name;
            this.stopReceiverLatitude = address.geometry.location.lat()
            this.stopReceiverLongtitude = address.geometry.location.lng()
    //       }else{
    //         this.spinner.hide();
    //         this.toastr.error("City not verified");
    //         this.stopReceiverLatitude = "";
    //         this.stopReceiverLongtitude = "";
    //         this.stopReceiverAddress=""
    //       }
    // })



  }

  disabledAllStopField=false;
  addStopage(){
      let data = {
        "address" : this.stopReceiverAddress , 
        "latitude" : this.stopReceiverLatitude,
        "longitude" : this.stopReceiverLongtitude,
        "receiverName" : this.stopReceiverName,
        "receiverPhoneNo" : this.stopReceiverNo
      }
      this.stopageArray.push(data);
      this.stopReceiverAddress  = "";
      this.stopReceiverLatitude = "";
      this.stopReceiverLongtitude = "";
      this.stopReceiverName = "";
      this.stopReceiverNo = "";
      if(this.stopageArray.length >= 4){
          this.disabledAllStopField = true;
      }else{
        this.disabledAllStopField = false;
      }
      console.log( this.stopageArray)
  }

  removeStopage(data){
    var index = this.stopageArray.indexOf(data);
    this.stopageArray.splice(index, 1); // Removes one element, starting from index
    this.disabledAllStopField = false;

  }

  async calculateDistanceBwLatLong(){
    if(this.senderAddress && this.receiverAddress){
      this.stopsBtn = true;
      this.directionsService.route({
        origin: this.senderAddress,
        destination: this.receiverAddress,
        travelMode: 'DRIVING'
      })   .then((response) => {
        this.directionsRenderer.setDirections(response);
        this.distance = response.routes[0].legs[0].distance.text
      }) .catch((e) =>  { 
        this.toastr.error("Directions request failed due to " )
        this.distance="";
        this.stopsBtn = false;
      } );
    
  }else{
    this.distance="";
    this.stopsBtn = false;
  }
  }


sendBySMS(value:any){
  this.isSendBySMS = value;
}

sendByEMAIL(value:any){
  this.isSendByEMAIL = value;
}

checkLabour(value:any){
  this.isLabourAvailable = value;
  this.calculateBillDetails();
}

openStopModal(content){
  this.openModal(content);
}


openModal(content) {
  this.modalService.open(content , {size : "lg"}).result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}

private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return `with: ${reason}`;
  }
}

  applyCoupon() {
    if (this.vehicleName) {
      const couponNumber = "1234";
      if (this.couponCode == couponNumber) {
        this.toastr.success("Coupon valid");
        this.isCouponValid = true;
        this.calculateBillDetails()


        // let labour_cost = this.selectedVehicleData.labourAvailable == true ? 100 : 0;
        // let coupon_cost = this.isCouponValid == true ? 200 : 0;

        // this.fareTip = Number(this.selectedVehicleData.discountedPrice) + Number(labour_cost) + Number(coupon_cost);
        // this.labourCost = labour_cost;
        // this.couponCost = coupon_cost
        // this.netFare = this.selectedVehicleData.discountedPrice;
        // this.totalAmount = this.selectedVehicleData.discountedPrice;

      } else {
        this.toastr.error("Oops, Coupon Invalid");
        this.isCouponValid = false;
      }
    } else {
      this.toastr.error("Please select vehicle")
    }
  }

}
